import {ActivityDictionary} from './activity.dictionary';
import {DatePipe} from '@angular/common';

declare const moment: any;

export class HistoryItem {
    loggedAt: string;
    userFullName: string;
    action: string;
    activityType: string;
    originActivityType: string;
    name: string;
    extra;
    data: { 'key': string, 'value': string }[] |
        { 'key': string, 'new': string, 'old': string }[] = [];

    static translate(str: string): string {
        return ActivityDictionary.getValue(str);
    }

    constructor(a) {
        this.loggedAt           = a.loggedAt;
        this.userFullName       = a.userFullName;
        this.activityType       = HistoryItem.translate(a.activityType);
        this.originActivityType = a.activityType;
        this.name               = a.name;
        this.extra              = a.extra;

        const keys = Object.keys(a.data);

        if (keys.length === 0 || (keys.length === 1 && keys[0] === 'extra')) {
            this.action = 'ignore';

        } else if(a.activityType == 'resident_instruction') {
            if (a.action === 'update') {
                if(Object.keys(a.data).indexOf('startDate') != -1) {
                    a.data.startDate.new = moment(a.data.startDate.new.slice(0, 10)).format('DD.MM.YYYY');
                    a.data.startDate.old = moment(a.data.startDate.old.slice(0, 10)).format('DD.MM.YYYY');
                }
                if(Object.keys(a.data).indexOf('endDate') != -1) {
                    a.data.endDate.new = moment(a.data.endDate.new.slice(0, 10)).format('DD.MM.YYYY');
                    a.data.endDate.old = moment(a.data.endDate.old.slice(0, 10)).format('DD.MM.YYYY');
                }
                this.defaultUpdate(a);
            } else {
                if(a.data.startDate)
                    a.data.startDate = moment(a.data.startDate.slice(0, 10)).format('DD.MM.YYYY');
                if(a.data.endDate)
                    a.data.endDate = moment(a.data.endDate.slice(0, 10)).format('DD.MM.YYYY');
                this.action = a.action;
                this.data = Object.keys(a.data).map((key) => {
                    return {
                        key: HistoryItem.translate(key),
                        value: this.checkAtDateOrTranslate(a.data[key], key)
                    };
                });
            }
        } else if (a.action == 'remove' && a.activityType == 'suite_user') {
            this.action = 'remove_suite_user';
            this.data = Object.keys(a.data).map((key) => ({
                            key: HistoryItem.translate(key),
                            value: this.checkAtDateOrTranslate(a.data[key], key)
                        }));
        } else if (a.action === 'update' && a.activityType === 'resident_phone') {
            const isPr = a.data.isPrimaryPhone;
            if (     isPr && isPr.new === 'yes' && isPr.old === 'no')  this.action = 'change_primary';
            else if (isPr && isPr.new === 'no'  && isPr.old === 'yes') this.action = 'ignore';
            else this.defaultUpdate(a, 'change_phone');

        } else if (a.action === 'update' && a.activityType === 'resident_address') {
            const isPr = a.data.isPrimaryAddress;
            if (     isPr && isPr.new === 'yes' && isPr.old === 'no')  this.action = 'change_primary';
            else if (isPr && isPr.new === 'no'  && isPr.old === 'yes') this.action = 'ignore';
            else this.defaultUpdate(a, 'change_address');

        } else if (a.action === 'update') {
            this.defaultUpdate(a);

        } else {
            this.action = a.action;
            this.data = Object.keys(a.data).map((key) => ({
                            key: HistoryItem.translate(key),
                            value: this.checkAtDateOrTranslate(a.data[key], key)
                        }));
        }
    }

    defaultUpdate(a, action = 'update') {
        this.action = action;
        this.data = Object.keys(a.data).map((key) => ({
                        'key': HistoryItem.translate(key),
                        'new': this.checkAtDateOrTranslate(a.data[key].new, key),
                        'old': this.checkAtDateOrTranslate(a.data[key].old, key)
                    }));
    }

    checkAtDateOrTranslate(value: string, key) {
        let matches = String(value).match(/\d{4}-\d{2}-\d{2}T\d{2}\:\d{2}\:\d{2}/g);
        if(matches) {
            const format = (key === 'dateOfBirth' || key === 'occupancyDate' || key === 'moveOutDate') ? 'dd.MM.yyyy' : 'dd.MM.yyyy h:mm:ss aa';
            value = new DatePipe('en-US').transform(value, format);
        }
        return HistoryItem.translate(value);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/activity/history-item.class.ts